import { QueryKey, useQuery } from "@tanstack/react-query";
import { getTrophies } from "../api/dashboard/trophyRoomAPI/getTrophies";
import { QUERY_KEYS } from "../constants/queryKeys";

interface useGetTrophiesProps {
  userId?: number;
  artistId?: number;
  engineerId?: number;
  studioId?: number;
  studioRoomId?: number;
}

enum trophyEntityQueryKey {
  USER = "user",
  ARTIST = "artist",
  ENGINEER = "engineer",
  STUDIO = "studio",
  STUDIO_ROOM = "studioRoom",
}

const getTrophyQueryKey = (params: useGetTrophiesProps): QueryKey => {
  const { userId, studioId, artistId, engineerId, studioRoomId } = params;

  if (artistId) {
    return [QUERY_KEYS.GET_TROPHIES, trophyEntityQueryKey.ARTIST, artistId];
  }

  if (engineerId) {
    return [QUERY_KEYS.GET_TROPHIES, trophyEntityQueryKey.ENGINEER, engineerId];
  }

  if (studioId) {
    return [QUERY_KEYS.GET_TROPHIES, trophyEntityQueryKey.STUDIO, studioId];
  }

  if (studioRoomId) {
    return [
      QUERY_KEYS.GET_TROPHIES,
      trophyEntityQueryKey.STUDIO_ROOM,
      studioRoomId,
    ];
  }

  if (userId) {
    return [QUERY_KEYS.GET_TROPHIES, trophyEntityQueryKey.USER, userId];
  }

  return [QUERY_KEYS.GET_TROPHIES];
};

export const useGetTrophies = ({
  userId,
  artistId,
  engineerId,
  studioId,
  studioRoomId,
}: useGetTrophiesProps) => {
  const queryKey = getTrophyQueryKey({
    userId,
    artistId,
    engineerId,
    studioId,
    studioRoomId,
  });

  return useQuery({
    enabled: Boolean(
      userId || artistId || engineerId || studioId || studioRoomId,
    ),
    queryKey,
    queryFn: async () => {
      return getTrophies({
        userId: Boolean(studioId) || Boolean(studioRoomId) ? undefined : userId,
        artistId,
        engineerId,
        studioId,
        studioRoomId,
      });
    },
    retry: 1,
  });
};
